import styled, { css } from 'styled-components';
import { AvatarProps, borderRadiusCalculator } from '.';

export const Container = styled.div<AvatarProps & { $erro: boolean }>`
  ${({ theme, $variant, $color, $size, $shape, $preencherFundo, $erro }) => {
    const cor =
      $variant === 'soft'
        ? theme.colors[$color][`${$color}_alpha`]['3']
        : theme.colors[$color][$color]['12'];

    const tamanho = theme.spacing[$size + 4];

    return css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      background-color: ${$preencherFundo || $erro ? cor : 'transparent'};
      width: ${tamanho}px;
      height: ${tamanho}px;
      border-radius: ${$shape === 'rounded' ? '50%' : `${theme.radius[2]}px`};
    `;
  }};
`;

export const ImageWrapper = styled.div<AvatarProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme, $size, $shape }) => {
    const borderRadius =
      $shape === 'rounded'
        ? '50%'
        : `${theme.radius[borderRadiusCalculator($size)]}px`;

    const tamanho = theme.spacing[$size + 4];

    return css`
      position: relative;
      border-radius: ${borderRadius};
      width: ${tamanho}px;
      height: ${tamanho}px;
    `;
  }}
`;

export const Texto = styled.p<{ $size: number; $color: string }>`
  ${({ theme, $size, $color }) => {
    return css`
      font-size: ${theme.typography.font.size[$size + 1]}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight.medium};
      line-height: ${theme.typography.font.line_height[$size]}px;
      text-align: center;
      color: ${$color};
    `;
  }};
`;
